import React from 'react';
import { Field, FormSection } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import { useFormatMessage } from 'components/IntlProvider';

interface SegmentType {
  id: number;
  value: string;
  label: string;
}

interface SegmentsProps {
  segments: SegmentType[];
}

const Segments = ({ segments }: SegmentsProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();

  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t(
          'fields.wizard.researchgoal',
          'Which of the following statements regarding the product test are you most likely to agree with?'
        )}
      </Typography>
      <FormSection name="segments">
        {segments.map(({ id, value, label }: SegmentType) => (
          <Field
            fullWidth
            key={id}
            component={Fields.Checkbox}
            value={value}
            label={label}
            name={String(value)}
          />
        ))}
      </FormSection>
    </>
  );
};

export default Segments;
